export const generateEventsRequest = (formData, eventId, EventTimeSlotId, EventLessonIndex, EventLocationId, Address, ZoomMeetingId, ZoomWebinarId, OtherZoomDetail, HowToGetThere) => {
    // Extract the number of sessions from formData
    const sessionNumbers = parseInt(formData?.sessionNumbers, 10);
    const noOfEventsRequest = [];

    // Loop through the session numbers to build the request dynamically
    for (let i = 1; i <= sessionNumbers; i++) {
        noOfEventsRequest.push({
            EventLessonId: null,
            EventTimeSlotId: EventTimeSlotId || null,
            EventLessonIndex: EventLessonIndex || null,
            EventLessonDate: formData[`date_${i}`] || null,
            EventStartTime: formData[`startAt_${i}`] || null,
            EventEndTime: formData[`endsAt_${i}`] || null,
            EventLocationId: EventLocationId || null,
            Address: Address || null,
            ZoomMeetingId: ZoomMeetingId || null,
            ZoomWebinarId: ZoomWebinarId || null,
            OtherZoomDetail: OtherZoomDetail || null,
            HowToGetThere: HowToGetThere || null,
        });
    }

    return noOfEventsRequest;
}


